export const PRINT_EVENT_KEYS = Object.freeze({
  QR_ORDER_CREATED: 'partner_ws_order_created',
  POS_ORDER_CREATED: 'pos_order_created',
  MANUAL_KITCHEN_PRINT: 'manual_kitchen_print',
  ACCOUNT_PRINT: 'account_print',
  INVOICE_SIMPLIFIED_PRINT: 'invoice_simplified_print',
  INVOICE_COMPLETE_PRINT: 'invoice_complete_print',
});

export const PRINT_EVENT_TEMPLATE_KEYS = Object.freeze({
  [PRINT_EVENT_KEYS.QR_ORDER_CREATED]: 'order_command',
  [PRINT_EVENT_KEYS.POS_ORDER_CREATED]: 'order_command',
  [PRINT_EVENT_KEYS.MANUAL_KITCHEN_PRINT]: 'order_command',
  [PRINT_EVENT_KEYS.ACCOUNT_PRINT]: 'account',
  [PRINT_EVENT_KEYS.INVOICE_SIMPLIFIED_PRINT]: 'account',
  [PRINT_EVENT_KEYS.INVOICE_COMPLETE_PRINT]: 'invoice_complete',
});

function normalizeText(value, fallback = '') {
  const normalized = String(value || '').trim();
  return normalized || fallback;
}

function createJobId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `print_job_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function resolveTemplateKeyForPrintEvent(eventKey) {
  return PRINT_EVENT_TEMPLATE_KEYS[normalizeText(eventKey)] || null;
}

export function buildPrintJob({
  eventKey,
  htmlContent = '',
  textFallback = '',
  template = null,
  templateSource = 'unknown',
  metadata = {},
  jobId = null,
  createdAt = null,
} = {}) {
  const normalizedEventKey = normalizeText(eventKey);
  const templateKey = normalizeText(
    template?.template_key,
    resolveTemplateKeyForPrintEvent(normalizedEventKey) || 'generic'
  );
  const normalizedJobId = normalizeText(
    jobId || metadata?.print_job_id || metadata?.job_id,
    createJobId()
  );
  const normalizedCreatedAt = createdAt || new Date().toISOString();

  return {
    job_id: normalizedJobId,
    event_key: normalizedEventKey,
    ticket_type: templateKey,
    html_content: String(htmlContent || ''),
    text_fallback: String(textFallback || ''),
    template_key: templateKey,
    template_version: Number(template?.version || 0) || null,
    template_source: normalizeText(templateSource, 'unknown'),
    metadata: {
      ...(metadata || {}),
      print_job_id: normalizedJobId,
      print_event: normalizedEventKey,
      print_template_key: templateKey,
      print_template_version: Number(template?.version || 0) || null,
      print_template_source: normalizeText(templateSource, 'unknown'),
      print_job_created_at: normalizedCreatedAt,
    },
    created_at: normalizedCreatedAt,
  };
}

export function toPrintAgentPayload(printJob, overrides = {}) {
  return {
    printer_name: overrides.printer_name || null,
    service_id: overrides.service_id || null,
    ticket_type: printJob.ticket_type || printJob.template_key || 'generic',
    content: printJob.text_fallback || '',
    html_content: printJob.html_content || '',
    metadata: {
      ...(printJob.metadata || {}),
      ...(overrides.metadata || {}),
    },
  };
}
